import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import get from 'lodash.get';

function mapProps(props) {
  if (typeof props.value === "boolean") return _objectSpread(_objectSpread({}, props), {}, {
    checked: props.value,
    value: void 0
  });
  return props;
}
function getError(formState, name) {
  var error = get(formState.errors, name);
  return error && error.message && error.message.length > 1 ? error.message : !!error;
}

export { getError, mapProps };
